/**
 * Customers tab model.
 *
 * Persons and Companies are consolidated into a single Customers page with
 * URL-driven tabs (?tab=…). Both tabs share the same `customers.read`
 * permission (enforced at the route), so there's no per-tab permission
 * clamping — just a resolve-or-default function to keep a crafted ?tab=
 * value from landing on an unmatched value (blank content).
 */

export type PartyTab = 'persons' | 'companies';

/**
 * Resolve a requested (URL) tab, defaulting to 'persons' for a missing or
 * unrecognized value.
 */
export function resolvePartyTab(requested: string | null): PartyTab {
  return requested === 'companies' ? 'companies' : 'persons';
}
